export default __webpack_public_path__ + "static/media/edificio.1120dcd0.svg";